import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-53658941"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "order-summary" }
const _hoisted_2 = {
  class: "order-summary__container",
  ref: "orderSummaryRef"
}
const _hoisted_3 = { class: "order-summary__title" }
const _hoisted_4 = { class: "content" }
const _hoisted_5 = { class: "summary-row" }
const _hoisted_6 = { class: "col-6" }
const _hoisted_7 = { class: "order-summary__key" }
const _hoisted_8 = { class: "col-5 offset-1" }
const _hoisted_9 = { class: "order-summary__value" }
const _hoisted_10 = { class: "col-6" }
const _hoisted_11 = { class: "order-summary__key" }
const _hoisted_12 = { class: "col-5 offset-1" }
const _hoisted_13 = { class: "order-summary__value" }
const _hoisted_14 = {
  key: 0,
  class: "summary-row"
}
const _hoisted_15 = { class: "col-6" }
const _hoisted_16 = { class: "order-summary__key" }
const _hoisted_17 = { class: "col-5 offset-1" }
const _hoisted_18 = { class: "order-summary__value" }
const _hoisted_19 = { class: "summary-row order-summary__total-row" }
const _hoisted_20 = { class: "col-6" }
const _hoisted_21 = { class: "order-summary__key" }
const _hoisted_22 = { class: "col-5 offset-1" }
const _hoisted_23 = { class: "order-summary__value" }
const _hoisted_24 = {
  key: 1,
  class: "summary-row"
}
const _hoisted_25 = { class: "col-6" }
const _hoisted_26 = { class: "order-summary__key" }
const _hoisted_27 = { class: "col-5 offset-1" }
const _hoisted_28 = { class: "order-summary__value" }
const _hoisted_29 = {
  key: 2,
  class: "summary-row"
}
const _hoisted_30 = { class: "col-6" }
const _hoisted_31 = { class: "order-summary__key" }
const _hoisted_32 = { class: "col-5 offset-1" }
const _hoisted_33 = { class: "order-summary__value" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("p", null, _toDisplayString(_ctx.$t("Cart.Title")), 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t("Cart.Items")), 1)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.showPricesAsB2b ? _ctx.summary.itemsExlServices.amountFormatted : _ctx.summary.itemsExlServices.amountIncVatFormatted), 1)
          ])
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.serviceItems, (service) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "summary-row",
            key: service.partNo
          }, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("span", _hoisted_11, _toDisplayString(service.name), 1)
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.showPricesAsB2b ? service.priceFormatted : service.priceIncVatFormatted), 1)
            ])
          ]))
        }), 128)),
        (!_ctx.isSuperUser)
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.$t("Cart.Freight")), 1)
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.showPricesAsB2b ? _ctx.summary.freight.amountFormatted : _ctx.summary.freight.amountIncVatFormatted), 1)
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.showPricesAsB2b ? _ctx.$t("Cart.TotalExlVat") : _ctx.$t("Cart.Total")), 1)
          ]),
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.showPricesAsB2b ? _ctx.summary.total.amountFormatted : _ctx.summary.total.amountIncVatFormatted), 1)
          ])
        ]),
        (!_ctx.showPricesAsB2b)
          ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.$t("Cart.Vat")), 1)
              ]),
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.summary.total.vatFormatted), 1)
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_29, [
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("span", _hoisted_31, _toDisplayString(_ctx.$t("Cart.VatB2b")), 1)
              ]),
              _createElementVNode("div", _hoisted_32, [
                _createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.summary.total.vatFormatted), 1)
              ])
            ]))
      ])
    ], 512)
  ], 512)), [
    [_vShow, !_ctx.hidePrices]
  ])
}